'use client'

import { ReactNode } from 'react'
import backgroundImg from '@/assets/img/background.webp'
import logo from '@/assets/img/stichting-open-logo.png'

type AppLayoutProps = {
    children: ReactNode
    unstyled?: boolean
}

export const AppLayout = ({ children, unstyled = false }: AppLayoutProps) => {
    return (
        <div className="h-full bg-shade-100">
            <main
                className={`${
                    !unstyled ? 'sm:grid sm:grid-cols-[minmax(0,_50%)_minmax(300px,_auto)]' : ''
                } h-screen w-full`}
            >
                <img
                    src={logo.src}
                    alt="Stichting Open"
                    className="h-12 w-auto absolute top-8 right-8 shrink-0 inline-flex"
                />
                {!unstyled && (
                    <div className="sm:h-screen">
                        <img
                            src={backgroundImg.src}
                            alt="A man carrying an electronic device to recycle"
                            className="h-[40vh] sm:h-full w-full object-[55%_50%] object-cover overflow-hidden"
                        />
                    </div>
                )}
                {children}
            </main>
        </div>
    )
}
